import { RootState } from "./store";

export const selectUserRoles = (state: RootState) =>
  state.auth.user?.roles || [];
export const selectIsAdmin = (state: RootState) =>
  selectUserRoles(state).includes("SystemAdmin");
